//MyKaizenHome
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode, faMedal, faClockFour, faListUl, faPlay, faLineChart, faPerson } from '@fortawesome/free-solid-svg-icons';
import './MyKaizenHome.css';
// import mykaizenimage from '../../assets/pageimages/MyKaizen.png';
// import MyKaizenAbout from './MyKaizenAbout';
import { logout } from "../../redux/actions/authActions";

function MyKaizenHome() {
  const authState = useSelector((s) => s.authReducer);
  const user = authState?.user || null;
  const isLoggedIn = !!user;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [userName, setUserName] = useState(user?.name || "");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/doe");
  };

  const kaizenLinks = [
    { path: "/mykaizen-smart", icon: faLineChart, label: "Using Kaizen for Betterment" },
    { path: "/kaizen/add", icon: faLineChart, label: "Create SMART Goal" },
    { path: "/mykaizen-list", icon: faLineChart, label: "SMART Goal List" },
    { path: "/mykaizen-mykaizen", state: { category: "Personal" }, icon: faPerson, label: "Personal Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Family" }, icon: faMedal, label: "Family Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Student" }, icon: faMedal, label: "Students Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Children" }, icon: faMedal, label: "Children Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Parent" }, icon: faMedal, label: "Parent Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Professional" }, icon: faMedal, label: "Professionals Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Social" }, icon: faMedal, label: "Social Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Worker" }, icon: faMedal, label: "Worker Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Operator" }, icon: faMedal, label: "Operator Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Factory" }, icon: faMedal, label: "Factory Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Manager" }, icon: faMedal, label: "Manage Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Engineer" }, icon: faMedal, label: "Engineer Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Healthcare" }, icon: faMedal, label: "Healthcare Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Business" }, icon: faMedal, label: "Business Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Government" }, icon: faMedal, label: "Government Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Institutions" }, icon: faMedal, label: "Educational Institutions Kaizen" },
    { path: "/mykaizen-mykaizen", state: { category: "Others" }, icon: faMedal, label: "Others Kaizen" }
  ];
  
  return (
    <div className="min-h-screen flex flex-col bg-black [&_p]:text-white [&_li]:text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">Kaizen</div>
          <div className="text-[11px] text-gray-200">Continuous Improvement Playground!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div className="min-h-full py-2 bg-black mt-4">
        {/* <h2 className='text-2xl font-bold text-white text-center mb-2'>MyKaizen</h2> */}
        {/* <div className="flex justify-center mb-6">
          <img src={mykaizenimage} alt="MyKaizen Analysis" style={{width:'300px', height: 'auto'}}className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md" />
        </div> */}
        <div className="ml-1 grid grid-cols-2 lg:grid-cols-4 gap-2 mx-2">
          {kaizenLinks.map((kaizen, index) => (
            <Link
              key={index}
              to={kaizen.path}
              state={kaizen.state}
              // className="flex items-center justify-center w-full max-w-xs p-4 bg-gradient-to-r from-teal-400 to-blue-500 text-white font-semibold rounded-lg shadow-md transform hover:scale-105 transition-all duration-300 ease-out sm:w-auto"
              className="flex flex-col items-center justify-center w-full p-1 bg-blue-600 hover:bg-blue-800 text-white font-semibold rounded-md shadow-sm"

            >
              <FontAwesomeIcon icon={kaizen.icon} className="mr-3 text-lg" />
              <span className="text-xs lg:text-sm font-semibold flex items-center justify-center text-center">{kaizen.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MyKaizenHome;
